import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMicrostrategyComponent } from './simple-icons-microstrategy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMicrostrategyComponent ],
    exports:      [ SimpleIconsMicrostrategyComponent ],
    bootstrap:    []
})
export class SimpleIconsMicrostrategyModule {}
